module.exports = __webpack_public_path__ + "img/index_06.9d2ccf6b.png";